import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import supabase from "@/lib/supabase";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const [recovering, setRecovering] = useState(false);
  const [failed, setFailed] = useState(false);

  // In the mobile app iframe, the session may be lost due to storage
  // partitioning. Attempt to re-establish it from URL tokens before giving up.
  useEffect(() => {
    if (loading || user || recovering || failed) return;

    const params = new URLSearchParams(window.location.search);
    const at = params.get("at");
    const rt = params.get("rt");
    const isApp = params.get("app") === "1";

    if (isApp && at && rt) {
      setRecovering(true);
      supabase.auth.setSession({ access_token: at, refresh_token: rt })
        .then(({ data, error }) => {
          if (error || !data?.session?.user) {
            setFailed(true);
          }
          // If successful, AuthContext's onAuthStateChange will pick it up
          // and set user, causing a re-render.
        })
        .catch(() => setFailed(true))
        .finally(() => setRecovering(false));
    } else {
      setFailed(true);
    }
  }, [loading, user, recovering, failed]);

  if (loading || recovering) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-brand-gold font-serif text-2xl animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user && failed) return <Navigate to="/login" replace />;
  if (!user) {
    // Still waiting for auth state to propagate
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-brand-gold font-serif text-2xl animate-pulse">Loading…</div>
      </div>
    );
  }
  return children;
}
